// src/api/dateSponsorApi.js
import axios from 'axios';
import endpoints from '../endpoints'

export const fetchDateSponsorList = async () => {
    const response = await axios.get(endpoints.dateSponsorList);

    const data = response.data.page;

    // 返回分頁資訊和內容
    return {
        content: data.content,
        totalPages: data.totalPages,
        totalElements: data.totalElements,
        pageNumber: data.pageable.pageNumber,
        pageSize: data.pageable.pageSize,
    };
};
